"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var javascript_time_ago_1 = __importDefault(require("javascript-time-ago"));
var en = __importStar(require("javascript-time-ago/locale/en"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var CommentServiceTypes_1 = require("../CommentServiceTypes");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var CommentTypes_1 = require("@CommonFrontendBackend/Comments/Types/CommentTypes");
var kaleidoscope_4 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
javascript_time_ago_1.default.addLocale(en);
var getResolveErrorTooltipContent = function (outcome) {
    var _a;
    if (!outcome) {
        throw new Error("Given an invalid outcome for getting error tooltip content");
    }
    else if (outcome === CommentServiceTypes_1.CommentResolveOutcome.Success || outcome === CommentServiceTypes_1.CommentResolveOutcome.None) {
        return "";
    }
    return (_a = {},
        _a[CommentServiceTypes_1.CommentResolveOutcome.LoggedOut] = "You've been logged out. Refresh the page to try again.",
        _a[CommentServiceTypes_1.CommentResolveOutcome.ThreadDeleted] = "This thread has been recently deleted. Refresh the page and try again.",
        _a[CommentServiceTypes_1.CommentResolveOutcome.UnknownFailure] = "Send error. Try again or refresh the page.",
        _a[CommentServiceTypes_1.CommentResolveOutcome.NetworkError] = "Connection error. Try again?",
        _a)[outcome];
};
var shouldRenderResolveTooltip = function (outcome) {
    return ![CommentServiceTypes_1.CommentResolveOutcome.None, CommentServiceTypes_1.CommentResolveOutcome.Success].includes(outcome);
};
var CommentComponent = (function (_super) {
    __extends(CommentComponent, _super);
    function CommentComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.isOptionsVisible = false;
        _this.isResolving = false;
        _this.resolvingOutcome = CommentServiceTypes_1.CommentResolveOutcome.None;
        _this.renderButtons = function () {
            var _a = _this.props, isResolved = _a.isResolved, isEditable = _a.isEditable, isFirst = _a.isFirst, hasEditAccess = _a.hasEditAccess;
            var buttonClassNames = (0, classnames_1.default)([
                "comment-component__button",
                { "comment-component__on-hover-button": !isResolved && !_this.isOptionsVisible },
            ]);
            var canEdit = hasEditAccess && !isResolved && isEditable;
            return (react_1.default.createElement("div", { className: "comment-component__button-holder center-aligned" },
                react_1.default.createElement("div", { className: buttonClassNames }, canEdit && _this.renderEditButton()),
                react_1.default.createElement("div", { className: buttonClassNames }, canEdit && _this.renderDeleteButton()),
                react_1.default.createElement("div", { className: buttonClassNames }, !isResolved && isFirst && _this.renderMoreCommentActions()),
                react_1.default.createElement("div", { className: "comment-component__resolve" }, hasEditAccess && isFirst && _this.renderCheckbox())));
        };
        _this.renderEditButton = function () {
            return (react_1.default.createElement(kaleidoscope_4.IconButton, { icon: react_1.default.createElement(icons_1.Edit, null), size: kaleidoscope_4.ButtonSize.Small, onClick: _this.props.editComment, tooltip: { content: "Edit" } }));
        };
        _this.renderDeleteButton = function () {
            return (react_1.default.createElement(kaleidoscope_4.IconButton, { icon: react_1.default.createElement(icons_1.Delete, null), size: kaleidoscope_4.ButtonSize.Small, onClick: _this.props.deleteComment, tooltip: { content: "Delete" } }));
        };
        _this.renderMoreCommentActions = function () {
            return react_1.default.createElement("div", { className: "comment-component__options-button" }, _this.renderOptionsMenu());
        };
        _this.renderOptionsMenu = function () {
            var _a = _this.props, hasEditAccess = _a.hasEditAccess, linkComment = _a.linkComment;
            return (react_1.default.createElement(kaleidoscope_4.OptionMenu, { className: "comment-component__option-menu", isOpen: _this.isOptionsVisible, onClose: _this.hideOptions, size: "small", button: react_1.default.createElement(kaleidoscope_4.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, null), onClick: _this.toggleOptions, size: kaleidoscope_4.ButtonSize.Small, tooltip: { content: "More actions" } }) },
                react_1.default.createElement(kaleidoscope_4.OptionMenuItem, { onClick: linkComment }, "Link to comment"),
                hasEditAccess && (react_1.default.createElement(kaleidoscope_4.OptionMenuItem, { onClick: function () { return _this.setIsResolved(CommentTypes_1.CommentThreadResolvedOrigin.OptionsMenu); } }, "Resolve"))));
        };
        _this.renderCheckbox = function () {
            var isResolved = _this.props.isResolved;
            var message = isResolved ? "Mark as unresolved" : "Mark as resolved";
            return (react_1.default.createElement(kaleidoscope_3.ErrorTooltip, { wrapTarget: true, size: kaleidoscope_1.TooltipSize.Large, content: getResolveErrorTooltipContent(_this.resolvingOutcome), renderTooltip: shouldRenderResolveTooltip(_this.resolvingOutcome) },
                react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, content: message },
                    react_1.default.createElement(kaleidoscope_2.Checkbox, { item: { id: "resolvedId", value: "checkbox", label: message }, labelHidden: true, isSelected: isResolved, toggleKey: "id", onChange: function () { return _this.toggleResolved(CommentTypes_1.CommentThreadResolvedOrigin.Checkbox); }, isDisabled: _this.isResolving }))));
        };
        _this.renderDate = function () {
            var _a = _this.props, createdAt = _a.createdAt, lastEditedAt = _a.lastEditedAt;
            var maybeEditedSuffix = createdAt.getTime() !== lastEditedAt.getTime() ? " (edited)" : "";
            return (react_1.default.createElement("div", { className: "comment-component__date" },
                _this.timeAgo.format(lastEditedAt),
                maybeEditedSuffix));
        };
        _this.toggleOptions = function () {
            _this.isOptionsVisible = !_this.isOptionsVisible;
            if (_this.isOptionsVisible) {
                _this.onClickOutside.startListening();
            }
            else {
                _this.onClickOutside.stopListening();
            }
        };
        _this.hideOptions = function () {
            _this.isOptionsVisible = false;
        };
        _this.setIsResolved = function (origin) {
            _this.setResolved(true, origin);
        };
        _this.toggleResolved = function (origin) {
            _this.setResolved(!_this.props.isResolved, origin);
        };
        _this.setResolved = function (isResolved, origin) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isResolving = true;
                        this.resolvingOutcome = CommentServiceTypes_1.CommentResolveOutcome.None;
                        return [4, this.props.setResolved(isResolved, origin)];
                    case 1:
                        result = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.isResolving = false;
                            _this.resolvingOutcome = result;
                        });
                        return [2];
                }
            });
        }); };
        _this.timeAgo = new javascript_time_ago_1.default("en-US");
        _this.onClickOutside = new utils_1.OnClickOutside([
            ".comment-component__options-button",
            ".comment-component__options-menu",
            ".modal-container",
        ], _this.hideOptions);
        return _this;
    }
    CommentComponent.prototype.render = function () {
        var _a = this.props, firstName = _a.firstName, lastName = _a.lastName, children = _a.children;
        return (react_1.default.createElement("div", { className: "comment-component space-inset-m" },
            react_1.default.createElement("div", { className: "comment-component__top-bar center-aligned" },
                react_1.default.createElement("div", { className: "comment-component__icon" },
                    react_1.default.createElement(kaleidoscope_4.Avatar, { firstName: firstName, lastName: lastName })),
                react_1.default.createElement("div", { className: "comment-component__details" },
                    react_1.default.createElement("div", { className: "comment-component__name" },
                        firstName,
                        " ",
                        lastName),
                    this.renderDate()),
                this.renderButtons()),
            react_1.default.createElement("div", { className: "comment-component__message" }, children)));
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], CommentComponent.prototype, "isOptionsVisible", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], CommentComponent.prototype, "isResolving", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof CommentServiceTypes_1.CommentResolveOutcome !== "undefined" && CommentServiceTypes_1.CommentResolveOutcome) === "function" ? _a : Object)
    ], CommentComponent.prototype, "resolvingOutcome", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommentComponent.prototype, "toggleOptions", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommentComponent.prototype, "hideOptions", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommentComponent.prototype, "setIsResolved", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommentComponent.prototype, "toggleResolved", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommentComponent.prototype, "setResolved", void 0);
    CommentComponent = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], CommentComponent);
    return CommentComponent;
}(react_1.default.Component));
exports.default = CommentComponent;
